module.exports = __webpack_public_path__ + "static/img/image10.07ce8a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image10.png
// module id = 26LW
// module chunks = 14